import { NgModule, importProvidersFrom } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Precision, TelemetryComponent } from './telemetry.component';
import { TelemetryRouteModule } from './telemetry-route.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import { TableModule } from 'primeng/table';
import { CoreModule } from '@app/core/core.module';
import { CalendarModule } from 'primeng/calendar';
import { ToastModule } from 'primeng/toast';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxModule } from 'primeng/checkbox';
import stock from 'highcharts/modules/stock';
import more from 'highcharts/highcharts-more';
import * as exporting from 'highcharts/modules/exporting.src';
import * as fullScreen from 'highcharts/modules/full-screen.src';
import * as accessibility from 'highcharts/modules/accessibility.js';
import * as offlineexporting from 'highcharts/modules/offline-exporting.src';
import { TelemetrySettingsComponent } from './telemetry-settings/telemetry-settings.component';
import { TelemetryDataComponent } from './telemetry-data/telemetry-data.component';
import { RequiredElementValidatorDirective } from '../shared/required-element-validator.directive';
import { NumberValidatorDirective } from '../shared/number-validator.directive';
import { EmailValidatorDirective } from '../shared/email-validator.directive';
import { MultiEmailValidatorDirective } from '../shared/multiEmail-validator.directive';
import { ValidateRulesService } from '../shared/validate-rules.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { ButtonModule } from 'primeng/button'
import { RadioButtonModule } from 'primeng/radiobutton';
import { SharedModule } from '../shared';
import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { NgxIndexedDBService } from 'ngx-indexed-db';
export function highchartsModules() {
  // apply Highcharts Modules to this array
  return [stock, more, exporting, fullScreen, offlineexporting, accessibility];
}

const dbConfig: DBConfig = {
  name: 'AppIndexDb',
  version: 1,
  objectStoresMeta: [{
    store: 'MasterExecIds',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'resourceId', keypath: 'resourceId', options: { unique: true } },
      { name: 'masterExecId', keypath: 'masterExecId', options: { unique: true } }
    ]
  }]
};

@NgModule({
  imports: [
    CommonModule,
    TelemetryRouteModule,
    FormsModule,
    ChartModule,
    NgbModule,
    TableModule,
    CoreModule,
    CalendarModule,
    ToastModule,
    TranslateModule,
    CheckboxModule,
    MultiSelectModule,
    RadioButtonModule,
    ButtonModule,
    SharedModule
  ],
  declarations: [TelemetryComponent, TelemetryDataComponent, TelemetrySettingsComponent, Precision, RequiredElementValidatorDirective,
    NumberValidatorDirective, EmailValidatorDirective, MultiEmailValidatorDirective],
  exports: [
    EmailValidatorDirective, MultiEmailValidatorDirective, RequiredElementValidatorDirective, NumberValidatorDirective
  ],
  providers: [ValidateRulesService, NgxIndexedDBService,
    [importProvidersFrom(NgxIndexedDBModule.forRoot(dbConfig))],
    { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules } // add as factory to your providers
  ]
})
export class TelemetryModule { }
